export default "__VITE_ASSET__01cf728c__"